import Inputz from "../atoms/Inputz";
import Buttonz from "../atoms/Buttonz";
import TitleZ from "../atoms/TitleZ";
import CountryDropDown from "../atoms/DropDownzCountry";
import DropDownz from "../atoms/DropDownz";
import TextAreaz from "../atoms/TextAreaz";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/compo.scss";
import SocialMedia from "./SocialMedia";
import ImageUploader from "../atoms/ImageUploader";
import { useDispatch } from "react-redux";
import { profileSubmit } from "../../utils/settingProfileValidation";
import AllPopups from "./AllPopups";
import UserCard from "./UserCard";
import SvgIcn from "../../data/IconCompo";
import Switchz from "../atoms/Switchz";
import {
  getFileUrl,
  refreshCurrentUser,
  normalizeUserRecord,
} from "../../auth/authApi";
import CenterTitleZ from "../atoms/CenterTitleZ";

const SOCIAL_KEYS = [
  "figma",
  "dribbble",
  "behance",
  "linkedin",
  "x",
  "instagram",
  "facebook",
  "tiktok",
];

function buildSocialOrderFromLinks(links) {
  const out = [];
  const seen = new Set();
  const arr = Array.isArray(links) ? links : [];
  arr.forEach((link) => {
    const t = String(link.type || "").toLowerCase();
    const key = t === "twitter" ? "x" : t;
    if (!SOCIAL_KEYS.includes(key) || !link.link) return;
    if (seen.has(key)) return;
    seen.add(key);
    out.push(key);
  });
  return out;
}

function SettingProfile({ userData, title, icon, content }) {
  const navigate = useNavigate();
  const [data, setData] = useState({});
  const [previosData, setPreviosData] = useState({});
  const [errors, setErrors] = useState({});
  const [visibleInputs, setVisibleInputs] = useState({
    figma: false,
    dribbble: false,
    behance: false,
    linkedin: false,
    x: false,
    instagram: false,
    facebook: false,
    tiktok: false,
  });
  const [socialOrder, setSocialOrder] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!userData) return;

    const user = normalizeUserRecord(userData);
    const resolvedSubRole =
      user?.sub_role ??
      user?.subRole ??
      user?.sub_role_ ??
      user?.subRole_ ??
      "";
    const links = Array.isArray(user.mediaLinks) ? user.mediaLinks : [];

    const avatarUrl = getFileUrl(user, user.avatar);

    const fromData = {
      username: user.username,
      fullName: user.fullName,
      nationality: user.nationality,
      subRole: resolvedSubRole,
      experience: user.experience,
      intro: user.intro,
      personalSite: user.personalSite,
      personalBlog: user.personalBlog,
      profile_img: avatarUrl || undefined,
      ...links.reduce(
        (acc, link) => ({
          ...acc,
          [link.type.toLowerCase()]: link.link,
        }),
        {}
      ),
    };

    setPreviosData(fromData);
    setData(fromData);

    const visibleSocialMedia = {};
    links.forEach((link) => {
      if (link.link) {
        visibleSocialMedia[link.type.toLowerCase()] = true;
      }
    });

    setVisibleInputs((prev) => ({
      ...prev,
      ...visibleSocialMedia,
    }));

    setSocialOrder(buildSocialOrderFromLinks(links));
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e;
    if (name === "experience") {
      const digitsOnly = String(value ?? "").replace(/[^\d]/g, "");
      const limited = digitsOnly.slice(0, 2);
      const normalized =
        limited === ""
          ? ""
          : String(Math.min(99, Math.max(0, parseInt(limited, 10) || 0)));
      setData((prev) => ({
        ...prev,
        [name]: normalized,
      }));
      setErrors((prev) => {
        return { ...prev, [`${name}`]: "" };
      });
      return;
    }
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => {
      return { ...prev, [`${name}`]: "" };
    });
  };

  const handleCancel = () => {
    setData({ ...previosData });
    setErrors({});
    setVisibleInputs((prev) => {
      const next = { ...prev };
      SOCIAL_KEYS.forEach((k) => {
        const v = previosData[k];
        next[k] = v != null && String(v).trim() !== "";
      });
      return next;
    });
    setSocialOrder((prev) => {
      const enabled = SOCIAL_KEYS.filter(
        (k) =>
          previosData[k] != null && String(previosData[k]).trim() !== ""
      );
      const kept = prev.filter((k) => enabled.includes(k));
      const missing = enabled.filter((k) => !kept.includes(k));
      return [...kept, ...missing];
    });
    const slug = previosData.username || userData?.username;
    if (slug) navigate(`/${encodeURIComponent(String(slug).trim())}`, { replace: true });
    else navigate("/", { replace: true });
  };

  const handleSubmit = async () => {
    if (JSON.stringify(previosData) !== JSON.stringify(data)) {
      const newErrors = await profileSubmit(
        dispatch,
        data,
        "en",
        visibleInputs,
        previosData
      );
      setErrors(newErrors);

      // If submission succeeded (no errors), resync from PocketBase (fresh avatar URL)
      if (newErrors && Object.keys(newErrors).length === 0) {
        const me = await refreshCurrentUser();
        if (me) {
          const u = normalizeUserRecord(me);
          const resolvedSubRole =
            u?.sub_role ?? u?.subRole ?? u?.sub_role_ ?? u?.subRole_ ?? "";
          const mlinks = Array.isArray(u.mediaLinks) ? u.mediaLinks : [];
          const avatarUrl = getFileUrl(u, u.avatar);
          const fromData = {
            username: u.username,
            fullName: u.fullName,
            nationality: u.nationality,
            subRole: resolvedSubRole,
            experience: u.experience,
            intro: u.intro,
            profile_img: avatarUrl || data.profile_img,
            personalSite: u.personalSite,
            personalBlog: u.personalBlog,
            ...mlinks.reduce(
              (acc, link) => ({
                ...acc,
                [link.type.toLowerCase()]: link.link,
              }),
              {}
            ),
          };

          const visibleSocialMedia = {};
          mlinks.forEach((link) => {
            if (link.link) visibleSocialMedia[link.type.toLowerCase()] = true;
          });
          setVisibleInputs((prev) => ({ ...prev, ...visibleSocialMedia }));
          setSocialOrder(buildSocialOrderFromLinks(mlinks));
          setData(fromData);
          setPreviosData(fromData);
        }
      }
    }
  };

  return (
    <div className="form-def-box">
      <CenterTitleZ
        title={title}
        icon={icon}
        content={content}
        className="setting-profile-title"
      />
      <div className="signup-hero left">
        <div className="signup-page-box">
          <ImageUploader
            addIcon={<SvgIcn name={"error"} />}
            deleteIcon={<SvgIcn name={"error"} />}
            onChange={(value) =>
              handleChange({ name: "profile_img", value: value })
            }
            error={errors?.profile_img}
            value={data.profile_img}
            onDelete={() => {
              handleChange({ name: "profile_img", value: undefined });
            }}
            className="avatar"
          />

          <div className="form-box">
            <div className="text-hint-box">
              Username can only include letters, numbers, and underscores. (max
              16 characters)
            </div>

            <Inputz
              iconL="username"
              label="Username"
              type="text"
              placeholder="Username"
              permanentPlaceholder="uud.io/"
              textCounter={16}
              usernameSlug={true}
              name="username"
              value={data.username}
              onChange={handleChange}
              error={errors?.username}
              className="username"
            />
            <Inputz
              iconL="user"
              label="Name"
              type="text"
              placeholder="Your Name"
              name="fullName"
              internationalName={true}
              textCounter={20}
              value={data.fullName}
              onChange={handleChange}
              error={errors?.fullName} // Pass error for full name
            />
            <CountryDropDown
              iconL="flag"
              focusL="cal"
              iconR="drop_down"
              iconRHover="drop_up"
              iconClear="clear"
              focusR="cal"
              hoverIconR="mail"
              placeholder="Your Laction"
              value={data.nationality}
              onSelect={handleChange}
              // value={data.nationality}
              name="nationality"
              error={errors?.nationality}
            />
            <DropDownz
              iconL="hum"
              // focusL="dots_on"
              iconR="drop_down"
              iconRHover="drop_up"
              iconClear="clear"
              focusR="cal"
              hoverIconR="mail"
              placeholder="Your Role"
              className="custom-input"
              onSelect={handleChange}
              value={data.subRole}
              name="subRole"
              error={errors?.subRole} // Pass error for role
            >
              <span>Product Designer</span>
              <span>UXUI Designer</span>
              <span>UX Designer</span>
              <span>UI Designer</span>
              <span>Others - Designer</span>
              <span>Researcher</span>
              <span>Frontend Developer</span>
              <span>Backend Developer</span>
              <span>Full Stack Developer</span>
              <span>Excutive</span>
              <span>Director</span>
              <span>Manager</span>
              <span>Marketer</span>
              <span>HR - Recruiter</span>
              <span>Student</span>
              <span>Others - Tech</span>
            </DropDownz>
            <div className="experience-box">
              <p>Years of experience:</p>
              <Inputz
                iconL="cal"
                // focusL="mail"
                label="Years of Experience"
                type="text"
                placeholder="0"
                name="experience"
                numbersOnly={true}
                value={data.experience || ""}
                onChange={handleChange}
                className="short"
                error={errors?.experience} // Pass error for experience
              />
            </div>
            <TextAreaz
              className="insider"
              title="Introduction"
              iconL="namecard"
              iconR="clear"
              value={data.intro || ""}
              maxLength={200}
              onChange={handleChange}
              name="intro"
              error={errors?.intro} // Pass error for introduction
            />
          </div>
          <div className="form-box">
            <SocialMedia
              iconOn="instagram_line"
              iconOff="instagram_line"
              data={data}
              handleChange={handleChange}
              visibleInputs={visibleInputs}
              setVisibleInputs={setVisibleInputs}
              errors={errors}
              setData={setData}
              socialOrder={socialOrder}
              setSocialOrder={setSocialOrder}
            />

            <div className="text-hint-box">
              Add your website, portfolio, and your personal content links.
            </div>

            <Inputz
              iconL="globe"
              // focusL="mail"
              hovericonR="mail"
              label="Email address"
              type="email"
              placeholder="Personal Website / Profile"
              onChange={handleChange}
              value={data.personalSite}
              name="personalSite"
              error={errors?.personalSite}
            />

            <Inputz
              iconL="blog_line"
              // focusL="mail"
              hovericonR="mail"
              label="Email address"
              type="email"
              placeholder="Personal Blog / Vlog / podcast"
              onChange={handleChange}
              value={data.personalBlog}
              name="personalBlog"
              error={errors?.personalBlog}
            />
          </div>

          <div className="form-box">
            <Buttonz
              iconR="ok"
              hoverR="ok"
              label="Save"
              onClick={handleSubmit}
            />
            <Buttonz
              iconR="close"
              hoverR="close"
              label="Cancel"
              className="lined"
              onClick={handleCancel}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingProfile;
